import { Typography } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { VerticalBox } from "src/components/common/box/VerticalBox";
import { ConfiguratorTreeItemInputErrors } from "src/components/views/erp/configurator/configuratorForm/configuratorTree/treeItemModel/ConfiguratorTreeItemInputErrors.ts";

export interface ConfiguratorTreeErrorsViewProps {
	errors: ConfiguratorTreeItemInputErrors;
}

export const ConfiguratorTreeErrorsView = ({ errors }: ConfiguratorTreeErrorsViewProps) => {
	return (
		<VerticalBox
			sx={{
				overflow: "auto",
				marginX: 2,
				marginY: 1,
				width: "100%",
			}}
		>
			<ConfiguratorTreeErrorsViewHelper treeItemErrors={errors} depth={0} />
		</VerticalBox>
	);
};

interface ConfiguratorTreeErrorsViewHelperProps {
	treeItemErrors: ConfiguratorTreeItemInputErrors;
	depth: number;
}

const ConfiguratorTreeErrorsViewHelper = ({
	treeItemErrors,
	depth,
}: ConfiguratorTreeErrorsViewHelperProps) => {
	return (
		<VerticalBox
			sx={{
				flex: "fit-content 0 0",
				marginLeft: depth,
				gap: 1,
			}}
		>
			{treeItemErrors.errors.map((error, index) => (
				<Typography key={index} color="error">
					{error}
				</Typography>
			))}
			{treeItemErrors.children.map((child, idx) => {
				return (
					<Fragment key={idx}>
						<Typography>{child.label}</Typography>
						<ConfiguratorTreeErrorsViewHelper treeItemErrors={child} depth={depth + 1} />
					</Fragment>
				);
			})}
		</VerticalBox>
	);
};
